/**
 * Filtros rápidos de Pedidos por etapa da operação. Cada chip escreve no filtro
 * da coluna Status; o refinamento fino fica no próprio filtro da coluna.
 * `shortLabel` é o texto do chip; `label` (nome completo) vai no title/aria-label
 * e nas descrições do filtro ativo.
 */
import { sameSet } from "./columnFilterState";

export const PRODUCT_STATUS_PRESETS = [
    { key: "a-caminho", label: "A caminho", shortLabel: "A caminho", statuses: ["APPROVED", "HOLD", "SENT"] },
    { key: "fila", label: "Fila de produção", shortLabel: "Fila", statuses: ["QUEUE", "GRADING", "GRADED"] },
    { key: "analise", label: "Em análise", shortLabel: "Análise", statuses: ["ANALYZING"] },
    { key: "retirada", label: "Aguardando retirada", shortLabel: "Retirada", statuses: ["AWAITING"] },
    { key: "pagamento", label: "Pagamento pendente", shortLabel: "Pagamento", statuses: ["GENERATED", "PIX", "PENDING", "PROCESSED"] },
    { key: "carrinhos", label: "Carrinhos", shortLabel: "Carrinhos", statuses: ["CART"] },
    { key: "finalizados", label: "Finalizados", shortLabel: "Finalizados", statuses: ["RETURNED", "DONE", "DELIVERED"] },
    { key: "cancelados", label: "Cancelados", shortLabel: "Cancelados", statuses: ["CANCELED"] },
    { key: "todos", label: "Todos", shortLabel: "Todos", statuses: null },
];

export const DEFAULT_PRODUCT_STATUSES = ["QUEUE", "GRADING", "GRADED"];

/** Chave do chip aceso para o filtro de status atual (undefined = sem filtro = Todos). */
export const matchStatusPreset = (presets, statuses) => {
    if (statuses === undefined) return presets.find((preset) => !preset.statuses)?.key ?? null;
    return presets.find((preset) => preset.statuses && sameSet(preset.statuses, statuses))?.key ?? null;
};

/** Descreve o conjunto: cobre com os maiores presets possíveis e lista o que sobrar. */
export const describeStatusSelection = (presets, labels, statuses) => {
    const remaining = new Set(statuses);
    const parts = [];
    const candidates = presets.filter((preset) => preset.statuses).sort((a, b) => b.statuses.length - a.statuses.length);
    for (const preset of candidates) {
        if (preset.statuses.every((status) => remaining.has(status))) {
            parts.push(preset.label);
            preset.statuses.forEach((status) => remaining.delete(status));
        }
    }
    const loose = [...remaining].map((status) => labels[status] ?? status);
    if (loose.length) {
        parts.push(loose.length <= 3 ? loose.join(", ") : `${loose.slice(0, 2).join(", ")} +${loose.length - 2}`);
    }
    return parts.join(" + ");
};

/** Contagem do chip a partir das facetas da coluna Status (já com os outros filtros). */
export const countPreset = (preset, facets) => {
    if (!facets) return undefined;
    if (!preset.statuses) {
        let total = 0;
        facets.forEach((count) => { total += count; });
        return total;
    }
    return preset.statuses.reduce((total, status) => total + (facets.get(status) ?? 0), 0);
};
